import axiosInstanceApiGateway from 'config/apiServiceApiGateway'
import type {
  GetMasterRateListResponseInterface,
  MasterRateBulkUploadResponseInterface,
} from 'features/Enterprise/Payroll/types'

export const getMasterRateList = (params: { role?: string; cursor?: string; page_size?: number }) =>
  axiosInstanceApiGateway.Get<GetMasterRateListResponseInterface, true>({
    url: 'staff-management/internal/:version/payroll/rate',
    params,
    version: 'v1',
    convertRequest: true,
  })

export const postUpsertRate = (data: {
  role: string
  rate_type: string
  base_pay: string
  ho: string
  ho2: string
  ot_2_4: string
  ot_4: string
  half_day: string
  onleave: string
  volunteer: string
  effective_date: string
}) =>
  axiosInstanceApiGateway.Post({
    url: 'staff-management/internal/:version/payroll/rate',
    data,
    version: 'v1',
    convertRequest: true,
  })

export const getMasterRateBulkUploadTemplate = () =>
  axiosInstanceApiGateway.Get<{ data: { file_url: string } }, true>({
    url: 'staff-management/internal/:version/payroll/rate/template',
    version: 'v1',
    convertRequest: true,
  })

export const postMasterRateBulkUpload = (data: FormData) =>
  axiosInstanceApiGateway.Post<{ data: MasterRateBulkUploadResponseInterface }, true>({
    url: 'staff-management/internal/:version/payroll/rate/bulk-upload',
    data,
    version: 'v1',
    convertResponse: true,
    config: {
      headers: {
        // eslint-disable-next-line @typescript-eslint/naming-convention
        'Content-Type': 'multipart/form-data',
      },
    },
  })
